module.exports = __webpack_public_path__ + "img/bg01.e7b989e0.jpg";